import { Dispatch, SetStateAction } from 'react';

interface HandleToggleAccordionProps {
  id: string;
  selectedId: string | null;
  headerOffset?: number;
  setSelectedId: Dispatch<SetStateAction<string | null>>;
}

export const handleToggleAccordion = ({
  id,
  headerOffset = 80,
  selectedId,
  setSelectedId,
}: HandleToggleAccordionProps) => {
  const isOpening = selectedId !== id;

  if (isOpening) {
    // Record the target element's current position
    const targetElement = document.querySelector(`[data-accordion-id="${id}"]`);
    const initialTop = targetElement
      ? targetElement.getBoundingClientRect().top
      : 0;

    // Change state
    setSelectedId((prev) => (prev === id ? null : id));

    // Immediately compensate for any jump, then smooth scroll
    requestAnimationFrame(() => {
      if (targetElement) {
        const newTop = targetElement.getBoundingClientRect().top;
        const diff = newTop - initialTop;

        // If position changed due to accordion closing above, compensate immediately
        if (Math.abs(diff) > 5) {
          // Only adjust if there's a significant jump
          window.scrollBy(0, diff);
        }

        // Now smooth scroll to the final position
        setTimeout(() => {
          const finalTop =
            targetElement.getBoundingClientRect().top +
            window.scrollY -
            headerOffset;
          window.scrollTo({
            top: finalTop,
            behavior: 'smooth',
          });
        }, 50);
      }
    });
  } else {
    // Just toggle for closing
    setSelectedId((prev) => (prev === id ? null : id));
  }
};
